import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';

import { TargetType } from 'types/target';

import Popup from 'components/Popup';
import SlidePanel from 'components/SlidePanel';

import Wrapper from './styled/Wrapper';
import Main from './styled/Main';
import Preloader from './styled/Preloader';
import PlayCanvasProject from './styled/PlayCanvasProject';

interface IndexPageProps {}

const IndexPage: React.FC<IndexPageProps> = ({ ...restProps }) => {
  const playCanvasFireRef = useRef<(eventName: string, ...args) => void>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [currentTarget, setCurrentTarget] = useState<TargetType>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const open = target => {
    if (target.type === 'region') {
      setIsPanelOpen(true);
    } else {
      setIsPopupOpen(true);
    }

    setCurrentTarget(findTarget(target));
  };

  const findTarget = target => {
    console.log(window['DATA'], target);
    return window['DATA'][target.type].find(obj => obj.name === target.id);
  };

  const dismissPopup = () => {
    setIsPopupOpen(false);
  };

  const dismissPanel = () => {
    setIsPanelOpen(false);
  };

  const onPlayCanvasEvent = (eventName: string, ...args) => {
    switch (eventName) {
      case 'panel:open':
        open(args[0]);
    }
  };

  const onLoadProgress = (progress: number) => {
    setLoadingProgress(progress);
  };

  const onLoadComplete = () => {
    setIsLoading(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      {...restProps}
    >
      <Wrapper>
        <Main>
          <PlayCanvasProject
            path="/playcanvas/map"
            disableInput={isLoading || isPanelOpen || isPopupOpen}
            refFire={playCanvasFireRef}
            onLoadProgress={onLoadProgress}
            onLoadComplete={onLoadComplete}
            onEvent={onPlayCanvasEvent}
          />
        </Main>
        <SlidePanel
          content={currentTarget?.content}
          isOpen={isPanelOpen}
          onDismiss={dismissPanel}
        />
        <Popup
          content={currentTarget?.content}
          isOpen={isPopupOpen}
          onDismiss={dismissPopup}
        />
        {isLoading && <Preloader progress={loadingProgress} />}
      </Wrapper>
    </motion.div>
  );
};

export default IndexPage;
